////////////// JQUERY CONFLICT NO PLEASE

(function ($) {

    ///////////////////////////////////
    ///////     FUNCTIONS     /////////
    ///////////////////////////////////

    ///////////////////////////////////
    /////// END GENERAL FUNCTIONS /////
    ///////////////////////////////////

    ///////////////////////////////////
    //////// THEME FUNCTIONS //////////
    ///////////////////////////////////

    window.hotel_offers = window.hotel_offers || function() {
        // check if i am in the hommmmme
        if (jQuery('body').hasClass('home')) {
            var offers_triggered = false;
            // check on scroll
            jQuery(window).scroll(function(){
                // limit of the offers
                var waypoint = jQuery('#offers_home').offset().top;
                if(jQuery(window).scrollTop() >= (waypoint-jQuery(window).height()) && !offers_triggered ){
                    // checker
                    offers_triggered = true;
                    // go offers
                    webSdkOffers();
                }
            });
        } else if (jQuery('body').hasClass('rooms')) {
            var rooms_offers_triggered = false;
            // check on scroll
            jQuery(window).scroll(function(){
                // limit of the offers
                var waypoint = jQuery('#children').offset().top;
                if(jQuery(window).scrollTop() >= (waypoint-jQuery(window).height()) && !rooms_offers_triggered ){
                    // checker
                    rooms_offers_triggered = true;
                    // go offers
                    webSdkOffers();
                }
            });
        } else {
            webSdkOffers();
        }
    };
    window.manipulateOffersBeforeRender = function (data, container) {
        if (data.prop.property == "czmar31277" || data.prop.property == "czmar31268" || data.prop.property == "czmar31276" ) {
            data.rates.reverse();
        }
    };
    ///////////////////////////////////
    ///////   END FUNCTIONS   /////////
    ///////////////////////////////////

    window.popup_all_pages = window.popup_all_pages || function(){
        if($('#popup_wrapper').size() > 0){
            $.fancybox.open({
                //forced popup scroll top
                opts : {
                    afterShow : function( instance, current ) {
                        $("html, body").animate({ scrollTop: 0 }, "fast");
                    }
                },
                src  : '#popup_wrapper',
                // type : 'inline',
                touch: false
            });
        }
    };


    // WINDOW RESIZE
    jQuery(window).resize(function () {

        // resizing images
        resize_images();

        // detecting screen dimensions
        refresh_size_queries();

        //  slideshow height
        slideshowHeight();

        // header
        header_scroll();

        // btn for booking
        open_bf_btn();

        // carousel offers for mobile
        carousel_offers_mobile();

    });

    // WINDOW SCROLL
    $(window).scroll(function () {

        // header
        header_scroll();

        // btn for booking
        open_bf_btn();

        // breadcrumb scroll
        breadcrumb_scroll();

    });


    /////////////// DOM READY
    $(document).ready(function() {

        // resizing images
        resize_images();

        // detecting screen dimensions
        refresh_size_queries();

        // select drop downs
        select_dd();

        // lazyloaddd
        lazy();

        // header
        header_scroll();

        //  slideshow height
        slideshowHeight();

        // SLIDESHOW
        doSlideshow('#slideshow .cycle');

        // lang menu open
        lang_menu_open();

        // btn for booking
        open_bf_btn();

        // mobile menu open
        mobile_menu_open();

        // opencloseviewmore
        opencloseviewmore();

        // btn scroll
        btn_scroll();

        // breadcrumb scroll
        breadcrumb_scroll();

        // offers
        // webSdkOffers();
        hotel_offers();

        // google map
        google_map();

        // children gallery
        child_gallery();

        // carousel_offers
        if(jQuery('.children_carousel').size()>0){
            carousel_offers();
        }

        // mobile carousel_offers
        if(jQuery('.item_carousel_mobile').size()>0){
            carousel_offers_mobile();
        }

        // photogallery
        window.photogallery();

        // newsletter
        box_newsletter();

        //
        popup_all_pages();



        //
        // // console.log(window.performance.memory);

    });

    jQuery(document).bind('gform_post_render', function(){

        // code to trigger on AJAX form render
        // gf_form();

    });

})(jQuery);

